import { render, staticRenderFns } from "./ValidatedShiftsReport.vue?vue&type=template&id=85af9ebc&"
import script from "./ValidatedShiftsReport.vue?vue&type=script&lang=ts&"
export * from "./ValidatedShiftsReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports